import { ParagraphAsHeading, StyledAlert } from "App/global-style";
import {
  AlertDescription,
  Button,
} from "Components/TextContext/commonComponentEnums";
import React, { ReactElement, useState } from "react";
import { OfferWrap, StyledDescription } from "./styled";

import Modal from "@storeblocks/modal";
import { useTexts } from "Components/TextContext";
import { Variants } from "Components/TextContext/textConstants";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { useCartSelector } from "Store/cart";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { buttonTrackId } from "Utils/analytics";
import { ResponsiveButton } from "../EditableCardFooter/editableCardFooterStyled";
import { getAdditonalDeleteProductText } from "./helpers";
interface Props {
  removeProductsInterceptor: (products: InsuranceProduct[]) => void;
  readonly products: InsuranceProduct[];
  readonly removeAllProducts?: boolean;
}

export const RemoveProductsModal = ({
  removeProductsInterceptor,
  products,
  removeAllProducts = false,
}: Props): ReactElement => {
  const { error, isLoading } = useCartSelector();
  const { getText } = useTexts();

  const [open, setOpen] = useState(false);

  const removeButtonText = removeAllProducts
    ? getText(Button.REMOVE_ALL)
    : getText(Button.REMOVE);
  const removeButtonId = removeAllProducts
    ? getText(Button.REMOVE_ALL, { variant: Variants.ENGLISH })
    : getText(Button.REMOVE, { variant: Variants.ENGLISH });
  const headerText = removeAllProducts
    ? getText("offer.removeproductdrawer.headerall")
    : getText("offer.removeproductdrawer.header");
  const drawerRemoveButtonText = removeAllProducts
    ? getText("offer.removeproductdrawer.removeall")
    : getText("offer.removeproductdrawer.remove");

  const handleRemoveProduct = (): void => {
    removeProductsInterceptor(products);
  };

  const openDrawer = (): void => {
    setOpen(true);
  };

  const closeDrawer = (): void => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      trigger={
        <ResponsiveButton
          variant="text"
          onClick={openDrawer}
          trackId={buttonTrackId(removeButtonId)}
          className={buttonTrackId(removeButtonId)}
          iconRight="delete"
          paddingRight={0}
        >
          {removeButtonText}
        </ResponsiveButton>
      }
      heading={<ParagraphAsHeading>{headerText}</ParagraphAsHeading>}
      content={
        <>
          <StyledDescription>
            {getText("offer.removeproductdrawer.description")}
            {getAdditonalDeleteProductText(products)}
          </StyledDescription>
          {error && !isLoading && (
            <StyledAlert
              title={getText(AlertDescription.SOMETHING_WENT_WRONG)}
              type="error"
            />
          )}
        </>
      }
      footer={
        <OfferWrap>
          {isLoading ? (
            <ThemedSpinner black />
          ) : (
            <div>
              <ThemedButton
                id={buttonTrackId("remove-product")}
                type="submit"
                trackId={buttonTrackId("remove-product")}
                onClick={handleRemoveProduct}
                disabled={isLoading}
              >
                {drawerRemoveButtonText}
              </ThemedButton>
              <ThemedButton
                id={buttonTrackId("remove-product__dismiss")}
                type="button"
                trackId={buttonTrackId("remove-product__dismiss")}
                variant="text"
                ml="8px"
                onClick={closeDrawer}
              >
                {getText(Button.CANCEL)}
              </ThemedButton>
            </div>
          )}
        </OfferWrap>
      }
      onClose={closeDrawer}
    />
  );
};
